// extracted by mini-css-extract-plugin
export default {"container":"BookmarkList_container__XogcN","bookmarkItem":"BookmarkList_bookmarkItem__8IUai"};